import Layout from 'components/layout';

import React, { type FC, type PropsWithChildren } from 'react';

import { Box, Heading, Text, Link, Container, Image, AccessibleDescription, SEO } from '@lucid/components-react';
import type { HeadFC } from 'gatsby';
import type { GatsbySite, Template } from 'types/types';

const NotFoundPage: FC<PropsWithChildren<Template.PageProps>> = ({ pageContext }) => {
  const { shortLangPrefix, pageType, nid, shouldHideSsr } = pageContext;

  return (
    <Layout
      entityTranslations={[]}
      nid={nid}
      pageType={pageType}
      shortLangPrefix={shortLangPrefix}
      shouldHideSsr={shouldHideSsr}
    >
      <Container extraPadding={3}>
        <Box css={{ textAlign: 'center', maxWidth: '580px' }} mx="auto" my={{ default: 5, tablet: 10 }}>
          <AccessibleDescription isForScreenReaderOnly as="h1" SRText="404 - Page not found" />
          <Heading as="h2" css={{ textAlign: 'center' }} variant="headline3XL">
            Sorry...
          </Heading>
          <Text variant="paragraphM400">We couldn&apos;t find the page you&apos;re looking for.</Text>
          <Link displayAsButton to="/">
            Return to the homepage
          </Link>
          <Box my={6}>
            <Image
              imageAlt="404 page not found"
              imageSrc="https://cdn-cashy-static-assets.lucidchart.com/lucidco/404/Lucidchart_404_page_579x326.svg"
            />
          </Box>
        </Box>
      </Container>
    </Layout>
  );
};

export default NotFoundPage;

export const Head: HeadFC<GatsbySite.Metadata, Template.PageProps> = ({ location }) => {
  const entityMetatags = [
    {
      key: 'title',
      value: '404 Page Not Found | Lucid Software',
    },
  ];

  return <SEO entityMetatags={entityMetatags} location={location} />;
};
